import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ThumbsUpIcon = createIcon({
  displayName: 'ThumbsUpIcon',
  d: 'M9.01 21H18c.8 0 1.52-.48 1.83-1.21l3.26-7.61c.85-1.98-.6-4.18-2.75-4.18h-5.65l.95-4.58c.1-.5-.05-1.01-.41-1.37-.29-.29-.67-.43-1.05-.43s-.77.15-1.06.44L7.59 7.6c-.37.37-.58.88-.58 1.41V19c0 1.1.9 2 2 2Zm4.33-16.33-.61 2.92-.5 2.41h8.11c.47 0 .72.28.83.45.11.17.27.51.08.95L18 19H9.01V9.01l4.33-4.34ZM3 21c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2s-2 .9-2 2v8c0 1.1.9 2 2 2Z',
  defaultProps: defaultProps
})
